import { DBEntity } from "./db";

const cachingDuration = 0; // 1000 * 60 * 5;

export const cacheExpired = (item?: DBEntity, overrideDuration?: number) =>
  !(
    item?.createdAtMS &&
    item?.createdAtMS > Date.now() - (overrideDuration ?? cachingDuration)
  );

export const auditEntity = (entity: DBEntity) => {
  entity.createdAtMS = Date.now();
  return entity;
};
